$('.banner__heading span:contains(Xtant)').each(function(){
  $(this).html(
    $(this).html().replace('Xtant','<span class=\'xtant\'>Xtant</span>')
  );
});

$('.banner__text span:contains(Opus)').each(function(){
  $(this).html(
    $(this).html().replace('Opus','<span class=\'opus\'>Opus</span>')
  );
});

$('.product__info-container .product__title:contains(Xtant)').each(function(){
  $(this).html(
    $(this).html().replace('Xtant','<span class=\'xtant\'>Xtant</span>')
  );
});

$('#shopify-section-template--15555595206887__1641922086faee873e .title-wrapper-with-link .title:contains(xtant red wine)').each(function(){
  $(this).html(
    $(this).html().replace('xtant red wine','<span class=\'split\'>xtant red wine</span>')
  );
});

$('#shopify-section-template--15555595206887__164192268781f8ef1d .title-wrapper-with-link .title:contains(most revered soil)').each(function(){
  $(this).html(
    $(this).html().replace('most revered soil','<span class=\'split\'>most revered soil</span>')
  );
});

$('#shopify-section-template--15555595206887__1641947073a512a557 .title-wrapper-with-link .title:contains(meticulous care from)').each(function(){
  $(this).html(
    $(this).html().replace('meticulous care from','<span class=\'split\'>meticulous care from</span>')
  );
});
	
	
	
	
	
/* ========================================================================
   PARALLAX
   ======================================================================== */

var bannerImage = gsap.utils.toArray('.banner');
var multicolumnImage = gsap.utils.toArray('section > .multicolumn > .page-width');

bannerImage.forEach((section) => {
	gsap.to(section.querySelectorAll("img"), {
		scrollTrigger: {
			trigger: section,
			scrub: 0.3
		},
		y: 200,
		ease: "none",
	});
});

multicolumnImage.forEach((section) => {
	gsap.to(section.querySelectorAll(".multicolumn-list__item.grid__item:nth-child(1), .multicolumn-list__item.grid__item:nth-child(3)"), {
		scrollTrigger: {
			trigger: section,
			scrub: 0.3
		},
		y: -200,
		ease: "none",
	});
});
  
var addCloseButton = (function() {
  var closeButton = setInterval(function() {
    if ($('.password-close-btn').length) {
      $('.password-close-btn').each(function(){
        $('.password-close-btn').on('click', function() {
          $('.klaviyo-form-UeE3nn').fadeOut(300);
        });
      });
      clearInterval(closeButton);
    }
  }, 100);
});





	
	
	
$(function(){
  
  
  $(window).resize(function(){
    var section1Height = $('#shopify-section-template--15555595206887__1641922086faee873e .multicolumn-list__item.grid__item:nth-child(3)').height();
    var section2Height = $('#shopify-section-template--15555595206887__164192268781f8ef1d .multicolumn-list__item.grid__item:nth-child(1)').height();
    var section3Height = $('#shopify-section-template--15555595206887__1641947073a512a557 .multicolumn-list__item.grid__item:nth-child(3)').height();
    var section4Height = $('#shopify-section-template--15555595206887__1641950121dda19371 .multicolumn-list__item.grid__item:nth-child(1)').height();
    $('#shopify-section-template--15555595206887__1641922086faee873e .multicolumn-list.grid').css({'min-height': section1Height + 'px'});
    $('#shopify-section-template--15555595206887__164192268781f8ef1d .multicolumn-list.grid').css({'min-height': section2Height + 'px'});
    $('#shopify-section-template--15555595206887__1641947073a512a557 .multicolumn-list.grid').css({'min-height': section3Height + 'px'});
    $('#shopify-section-template--15555595206887__1641950121dda19371 .multicolumn-list.grid').css({'min-height': section4Height + 'px'});
  });

  $(window).ready(function () {
    $(window).trigger('resize');
    if(window.location.hash) {
      var hash = window.location.hash;
      var windowWidth = $(window).innerWidth();
      if (hash == "#our-wine") {
        hash = "#shopify-section-template--15555595206887__1641922086faee873e";
      } else if (hash == "#vineyard") {
        hash = "#shopify-section-template--15555595206887__164192268781f8ef1d";
      } else if (hash == "#vine-to-bottle") {
        hash = "#shopify-section-template--15555595206887__1641947073a512a557";
      } else if (hash == "#our-founder") {
        hash = "#shopify-section-template--15555595206887__1641950121dda19371";
      }
      if(windowWidth > 980){
        $('html, body').animate({scrollTop: $(hash).offset().top - 100}, 600, 'easeInOutQuad');
      } else if(windowWidth < 980 && windowWidth > 760) {
        $('html, body').animate({scrollTop: $(hash).offset().top - 150}, 600, 'easeInOutQuad');
      } else if(windowWidth < 761) {
        if (hash == "#shopify-section-template--15555595206887__1641922086faee873e" || hash == "#shopify-section-template--15555595206887__1641947073a512a557") {
          $('html, body').animate({scrollTop: $(hash).offset().top - 275}, 600, 'easeInOutQuad');
        } else {
          $('html, body').animate({scrollTop: $(hash).offset().top - 400}, 600, 'easeInOutQuad');
        }
      }
    }
  });
	
  /* ========================================================================
     ANCHOR BUTTONS
  ======================================================================== */
  
  $('.menu-drawer__menu a[href*="#"]').each(function() {
      $(this).on('click', function(event) {
        var hash = this.hash;
        var windowWidth = $(window).innerWidth();
        if (hash == "#our-wine") {
          hash = "#shopify-section-template--15555595206887__1641922086faee873e";
        } else if (hash == "#vineyard") {
          hash = "#shopify-section-template--15555595206887__164192268781f8ef1d";
        } else if (hash == "#vine-to-bottle") {
          hash = "#shopify-section-template--15555595206887__1641947073a512a557";
        } else if (hash == "#our-founder") {
          hash = "#shopify-section-template--15555595206887__1641950121dda19371";
        }
        if(windowWidth > 980){
          $('html, body').animate({scrollTop: $(hash).offset().top - 100}, 600, 'easeInOutQuad');
        } else if(windowWidth < 980 && windowWidth > 760) {
          $('html, body').animate({scrollTop: $(hash).offset().top - 150}, 600, 'easeInOutQuad');
        } else if(windowWidth < 761) {
          if (hash == "#shopify-section-template--15555595206887__1641922086faee873e" || hash == "#shopify-section-template--15555595206887__1641947073a512a557") {
            $('html, body').animate({scrollTop: $(hash).offset().top - 275}, 600, 'easeInOutQuad');
          } else {
            $('html, body').animate({scrollTop: $(hash).offset().top - 400}, 600, 'easeInOutQuad');
          }
        }
  	  });
  });
	
  
  /* ========================================================================
     PASSWORD PAGE
  ======================================================================== */
  
  $('.password-module__join-allocation-list a').on('click', function(event) {
    event.preventDefault();
    $('.klaviyo-form-UeE3nn').fadeIn(300);
    $('.klaviyo-form-UeE3nn > div > form').append("<div class='password-close-btn'><span></span><span></span></div>");
    addCloseButton();
  });

  var passwordButton = setInterval(function() {
    if ($('.klaviyo-form-UeE3nn > div > form button.go2864329267:contains(BACK TO SITE)').length) {
      $('.klaviyo-form-UeE3nn > div > form button.go2864329267:contains(BACK TO SITE)').each(function(){
        $(this).on('click', function() {
          $('.password-module__join-allocation-list').html('Please expect an email shortly containing detailed instructions.');
          $('.klaviyo-form-UeE3nn').fadeOut(300);
        });
      });
      $('.password-close-btn').each(function(){
        $(this).on('click', function() {
          $('.password-module__join-allocation-list').html('Please expect an email shortly containing detailed instructions.');
          $('.klaviyo-form-UeE3nn').fadeOut(300);
        });
      });
      clearInterval(passwordButton);
    }
  }, 100);
  
});

